var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var Conditions = (function() {

    var _requestConditions= function() {
      return {
        type: constants.REQUEST_CONDITIONS
      };
    }

    var _receiveConditions = function(data) {
      return {
        type: constants.RECEIVE_CONDITIONS,
        conditions: data.conditions,
        receivedAt: Date.now()
      };
    }

    var _fetchConditions = function() {
      return function (dispatch) {
        dispatch(_requestConditions());
        return api.get('/proxy/v1/conditions?fields=name,displayName,friendlyUrl,title,popup,firstButton')
          .then(function (data) {
            dispatch(_receiveConditions(data));
          }).catch(function(error){
            if(error.respone){
              // console.log(error.respone);
            }else{
              dispatch(commonActions.setGenericError('', error.message));
            }
          });
      };
    }

    var _shouldFetchConditions = function(state) {
      var conditions = state.conditions
      if (!(conditions.items && conditions.items[0])) {
        return true
      } else {
        return false
      }
    }

    var _fetchConditionsIfNeeded = function() {
      return function(dispatch, getState) {
        if (_shouldFetchConditions(getState())) {
          return dispatch(_fetchConditions())
        }
      }
    }

    var _setActiveCondition = function(condition) {
      return {
        type: constants.SET_ACTIVE_CONDITION,
        condition: condition
      };
    }

    var _resetActiveCondition = function() {
      return {
        type: constants.RESET_ACTIVE_CONDITION
      };
    }

    return {
        fetchConditionsIfNeeded: _fetchConditionsIfNeeded,
        setActiveCondition: _setActiveCondition,
        resetActiveCondition: _resetActiveCondition
    }
})();

module.exports = Conditions;



// WEBPACK FOOTER //
// ./src/common/modules/conditions/actions/conditions.js